module.exports = __webpack_public_path__ + "img/R. Jaim Y. Rosenberg.38b772fe.png";